<template>
  <div class="sub-menu">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'NavSubMenu'
}
</script>

<style>

</style>
